function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
export function Star(props) {
  var updatedEvents = {};
  Object.entries(props.events).forEach(function (handler) {
    updatedEvents[handler[0]] = function (event) {
      event.preventDefault();
      event.stopPropagation();
      handler[1](props.i);
    };
  });
  return React.createElement("i", _extends({
    className: "ui icons"
  }, updatedEvents), React.createElement("i", {
    className: "".concat(props.starColor, " ").concat(props.inverted ? 'inverted' : '', " outline star icon")
  }), React.createElement("i", {
    className: "".concat(props.starColor, " ").concat(props.inverted ? 'inverted' : '', " ").concat(props.starClass, " star icon")
  }));
}